'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import ErrorPage from '../containers/ErrorPage';

export default function GlobalError(props) {
    const { error } = props;

    useEffect(() => {
        Sentry.captureException(error);
        console.error('[ERROR]: ', error);
    }, [error]);

    return <ErrorPage />;
}
